import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Input, InputGroup, Row } from 'reactstrap';
import { getCompanies } from '../actions/Companies';
import { getLocationByCompany } from '../actions/EpikBoxes';
import CompanyAutocomplete from './CompanyAutocomplete';
import LocationDetails from './LocationDetails';
import './monitorFilter.css';
const filterStatusOptions = [{ value: true, label: 'Open' }, { value: false, label: 'Closed' }];

const MonitorFilter = ({ filterObject }) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;
  const companies = useSelector(state => state.AppState.companies);
  const boxLocations = useSelector(state => state.AppState.boxDetails.boxLocations);
  const [locationStatus, setLocationStatus] = useState(false);
  const [filter, setFilter] = useState({
    company: '',
    location: '',
    alert: '',
    serialNumber: '',
    from: '',
    to: '',
    status: true,
  });

  useMemo(() => {
    filterObject(filter);
  }, [filter]);

  useEffect(() => {
    dispatch(getCompanies(token, undefined, 'yes'));
  }, []);
  const onFilterChange = (change, type) => {
    if (type === 'company' && !change.value) {
      setLocationStatus(false);
      setFilter({ ...filter, company: '' });
      dispatch(getCompanies(token, undefined, 'yes'));
    } else if (type === 'company' && !!change.value) {
      setLocationStatus(true);
      dispatch(getLocationByCompany(token, change.suggestion._id));
      setFilter({ ...filter, company: change.suggestion._id });
    } else {
      setFilter({ ...filter, [change.currentTarget.name]: change.currentTarget.value });
    }
  };

  return (
    <div className="filter-container">
      <Row>
        <Col>
          <Row>
            <h1>Company</h1>
            <>
              <CompanyAutocomplete
                className="testing-filter"
                placeholder="Filter"
                companies={companies.docs}
                onChange={e => onFilterChange(e, 'company')}
              />
            </>
          </Row>
          {/* {locationStatus && (
            <Row className="location-container">
              <h1>Location</h1>
              <Col>
                <LocationDetails
                  className="testing-filter"
                  boxesLocation
                  selectLocation={e => onFilterChange(e, 'location')}
                  locations={boxLocations}
                />
              </Col>
            </Row>
          )} */}

          <Row>
            <h1>Location</h1>
            <Input
              type="text"
              name="location"
              placeholder={`Location`}
              value={filter.location}
              onChange={e => onFilterChange(e, 'location')}
              style={{ marginBottom: '1em' }}
            />
          </Row>

          <Row>
            <h1>Serial Number</h1>
            <Input
              type="text"
              name="serialNumber"
              placeholder={`Serial Number`}
              value={filter.serialNumber}
              onChange={e => onFilterChange(e, 'serialNumber')}
              style={{ marginBottom: '1em' }}
            />
          </Row>
          <Row>
            <h1>Status</h1>
            <Input
              type="select"
              name="status"
              style={{ marginBottom: '1em' }}
              onChange={e => onFilterChange(e, 'status')}
            >
              {filterStatusOptions.map(el => (
                <option key={el.value} value={el.value}>
                  {el.label}
                </option>
              ))}
            </Input>
          </Row>
          <Row>
            <h1>Alert</h1>
            <Input
              type="text"
              name="alert"
              value={filter.alert}
              placeholder={`Alert`}
              style={{ marginBottom: '1em' }}
              onChange={e => onFilterChange(e, 'alert')}
            />
          </Row>
          <Row>
            <h1>Date Range</h1>
            <Row>
              <Col md={5}>
                <Input
                  placeholder="Please specify"
                  required
                  type="date"
                  name="from"
                  value={filter.from}
                  onChange={e => onFilterChange(e, 'dateRange')}
                />
              </Col>
              <Col md={1}>
                <p style={{ marginTop: '5px' }}>To</p>
              </Col>
              <Col md={5}>
                <Input
                  placeholder="Please specify"
                  required
                  type="date"
                  name="to"
                  value={filter.to}
                  onChange={e => onFilterChange(e, 'dateRange')}
                />
              </Col>
            </Row>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default MonitorFilter;
